export default "__VITE_ASSET__Df6V3_w4__"